const KILO = 1024;
const sizeUnits: Array<keyof SizeLocales> = [
  'byte',
  'kilobyte',
  'megabyte',
  'gigabyte',
  'terabyte',
];

export interface SizeLocales {
  byte: string;
  kilobyte: string;
  megabyte: string;
  gigabyte: string;
  terabyte: string;
}

interface FormatFileSizeArgs {
  sizeInBytes: number;
  decimals: number;
  locales: SizeLocales;
}

export const formatFileSize = ({
  sizeInBytes,
  decimals,
  locales,
}: FormatFileSizeArgs): string => {
  if (sizeInBytes === 0) {
    return `0${locales.byte}`;
  }

  const i = Math.floor(Math.log(sizeInBytes) / Math.log(KILO));
  const boundedIndex = Math.min(i, sizeUnits.length - 1);
  const size = sizeInBytes / Math.pow(KILO, boundedIndex);

  // Round to specified decimals
  const formattedSize =
    decimals > 0 ? size.toFixed(decimals) : Math.round(size).toString();

  const sizeUnit = sizeUnits[boundedIndex];
  return `${formattedSize}${locales[sizeUnit]}`;
};
